var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v("时间范围:  ")]),_c('a-range-picker',{staticStyle:{"width":"320px"},attrs:{"allowClear":false,"size":"small","format":_vm.timeType == 'sec'
        ? 'yyyy-MM-DD HH:mm:ss'
        : _vm.timeType == 'min'
        ? 'YYYY-MM-DD HH:mm'
        : _vm.timeType == 'hour'
        ? 'YYYY-MM-DD HH'
        : 'YYYY-MM-DD',"show-time":_vm.timeType == 'sec'
        ? { format: 'HH: mm: ss' }
        : _vm.timeType == 'min'
        ? { format: 'HH: mm' }
        : _vm.timeType == 'hour'
        ? { format: 'HH' }
        : false,"ranges":_vm.ranges[_vm.timeType],"disabledDate":_vm.disabledDate},on:{"change":_vm.onDateRangeChange,"openChange":_vm.pickerOpenChange,"ok":_vm.onDateRangeOk},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }